import React from "react";
import { HTMLAttributes } from "react";

interface IProgressBarProps extends HTMLAttributes<HTMLDivElement> {
    value: number;
}

const ProgressBar = (props: IProgressBarProps) => {
    const { value, className, ...moreProps } = props;

    return <div className={"progress-bar " + (className || "")} {...moreProps}>
        <div className="progress-bar-inner" style={{ width: `${value}%` }} />
    </div>;
};

export default ProgressBar;